<template>
  <div class="liveSchedule">
    <div class="title">配信予定管理</div>
    <section class="section">
      <IvsInformation/>
    </section>
    <section class="section submit-button has-text-centered">
      <b-button class="button submit" @click="registraion()">新しい配信予定を登録</b-button>
    </section>
    <section class="section list">
      <div class="container">
        <LiveListedRow
          v-for="live in recentLives"
          :key="live.id"
          :tileData="{
            liveId: live.id,
            imageSrc: live.thumbnailURL,
            nickname: live.performerNickname,
            startAt: live.startAt,
            title: live.title,
            type: 'recent',
            disabled: false
          }"
          @update="update"
          @action="moveConsole"
        />
        <LiveListedRow
          v-for="live in upComingLives"
          :key="live.id"
          :tileData="{
            liveId: live.id,
            imageSrc: live.thumbnailURL,
            nickname: live.performerNickname,
            startAt: live.startAt,
            title: live.title,
            type: 'upComing',
            disabled: recentLives.length > 0
          }"
          @update="update"
          @action="startStreaming"
        />
      </div>
    </section>
  </div>
</template>

<script>
import LiveListedRow from '@/components/Molecules/LiveListedRow';
import IvsInformation from '@/components/IvsInformation';
import * as liveServices from '@/services/liveServices';
import * as modal from '@/utils/modal';
import * as DateTime from '@/utils/date';

export default {
  name: 'LiveSchedule',
  components: {
    LiveListedRow,
    IvsInformation
  },
  data() {
    return {
      recentLives: [],
      upComingLives: []
    };
  },
  async created() {
    await this.$store.dispatch('live/initStore');
    await this.reload(this.$store.state.auth.uid);
  },
  methods: {
    async reload(uid) {
      let userId = uid;
      this.recentLives = await liveServices.getRecentLivesByPerformerId(userId, 100);
      this.upComingLives = await liveServices.getUpcomingLivesByPerformerId(userId, 1000);
    },
    registraion() {
      this.$emit("action", {
        mode: "registration"
      })
    },
    update(liveId) {
      this.$emit("action", {
        mode: "update",
        liveId: liveId
      })
    },
    startStreaming(data) {
      modal.confirm(this, "",
        `${DateTime.formatJSDate('yyyy/MM/dd HH:mm', data.startAt)}日時配信開始予定の配信を開始しますか？`,
        null, async () => {
          await this.execStartStreaming(data.liveId);
        }
      );
    },
    async execStartStreaming(id) {
      if (!id) {
        return;
      }
      let upComingLive = null;
      for (var item of this.upComingLives) {
        if (item.id == id) {
          upComingLive = item;
        }
      }
      if (!upComingLive) {
        return;
      }

      try {
        const liveDoc = {
          title: upComingLive.title,
          thumbnailURL: upComingLive.thumbnailURL,
          playbackUrl: this.$store.state.ivs.channel.playbackUrl,
          startAt: null,
          nowReserveId: null,
          upComingLive: upComingLive,
          freeViewUsers: [],
          paidViewUsers: [],
        };
        await this.$store.dispatch('startLiveStreaming', {
          userId: this.$store.state.auth.uid,
          liveId: upComingLive.id,
          liveDoc: liveDoc
        });
        await this.reload(this.$store.state.auth.uid);
        //this.moveConsole(id);
      } catch (err) {
        console.error(err);
        return;
      }
    },
    moveConsole(data) {
      this.$router.push(`/live/console/${data.liveId}`);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/live-schedule.scss';
</style>
